
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./main.css";


const API_KEY = process.env.REACT_APP_API_URL


export function AsideBox() {

   const [data, setData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            const res = await axios.get(`${API_KEY}/api/apps/`);
            const allApps = res?.data?.apps

            const featuredApps = allApps.filter((app) => {
               return app.isFeatures === true
            })

            setData(featuredApps);
         } catch (err) {
            console.error("Error fetching apps:", err.message);
         }
      };
      fetchData();
   }, []);

   return (
      <>
         <h1 style={{fontWeight: "bolder"}}>Featured*</h1>
         <div className="aside-wrapper">
            <div className="aside-grid">
               {data?.map((app, index) => (
                  <div className="app-card" key={index}>
                     <div className="app-card-body">
                        <div className="app-card-header">
                           <img
                                src={`${API_KEY}/temp/${app?.company_logo}`}
                              className="app-logo"
                              alt="logo"
                           />
                           <div className="app-title">{app.name}</div>
                        </div>
                        <div className="app-description">
                           {app.description?.length > 40
                              ? app.description.slice(0, 40) + "..."
                              : app.description}
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>

      </>
   );

}